import Vue from 'vue'
import Vuex from 'vuex'
import goodsInfo from './goods-info'
import orderInfo from './order-info'
import _ from "lodash";
import wwwHiworksapi from "@/apis/www-hiworks-api";
import oracleHelper from "@/js/helper/oracle";

Vue.use(Vuex)

const initialState = () => {
  return {
    loading: true
  }
}

const getters = {

}

const mutations = {
  setLoading(state, isLoading){
    state.loading = isLoading
  },
  setTermPriceList(state) {
    let packageGoodsIdList = _.flatMap(state.order_info.packageGoods, (packageGoodsInfo) => {
      return parseInt(packageGoodsInfo.goods_id)
    })
    let subGoodsInfoList = state.order_info.checkedSubGoodsList

    let termPriceList = _.chain(state.goods_info.package_info.goods_term_prices)
        .filter((mainGoodsTermPriceInfo)=>{ // 1. 주 상품 필터링
          return packageGoodsIdList.includes(mainGoodsTermPriceInfo.id)
        })
        .flatMap((mainGoodsTermPriceInfo)=>{    // 2. sub_goods 필터링
          let cloneTermPriceInfo = _.clone(mainGoodsTermPriceInfo)


          cloneTermPriceInfo.sub_goods =
              _.filter(cloneTermPriceInfo.sub_goods, (subGoodsInfo)=>{
                // 2.1 파라미터로 넘어온 subGoodsList의 정보와 main_goods_id와 sub_goods_id가 동일한것들만
                // 다시 cloneTermPriceInfo의 sub_goods에 매핑

                let findResult = _.find(subGoodsInfoList, (findSubGoodsInfo)=>{
                  return findSubGoodsInfo.main_goods_id === cloneTermPriceInfo.id
                      && findSubGoodsInfo.id === subGoodsInfo.id
                });

                return !!findResult

              })

          return cloneTermPriceInfo
        })
        .value()

    state.order_info.termPriceList = termPriceList
  },
}

const actions = {
  init({dispatch, getters, commit}, {packageId, selectGoodsId}){
    dispatch('goods_info/loadPackageInfo', {packageId})
        .then(() => {
          return dispatch('goods_info/setPackageGoods', selectGoodsId)
        })
        .then(() => {
          let orderInfo = {}
          orderInfo.packageId = packageId
          orderInfo.payTerm = getters["goods_info/getDefaultPayTerm"]
          orderInfo.termUnit = getters["goods_info/getDefaultTermUnit"]

          let addMonthDate = oracleHelper.getAddMonthOracle(new Date(), orderInfo.payTerm)
          commit('order_info/setExpireDate', addMonthDate)

          return dispatch('order_info/setOrderInfo', orderInfo)
        })
        .then(() => {
          return dispatch('order_info/changePackageGoods', getters['goods_info/getPackageGoods'])
        })
        .then(() => {
          return commit('setTermPriceList')
        })
        .then(()=>{
          return commit('setLoading', false)
        })
  },
  changeSelectGoodsInit({dispatch, getters, commit}, selectGoodsId){
    dispatch('goods_info/setPackageGoods', selectGoodsId)
    dispatch('goods_info/setPackageGoods', selectGoodsId)
    dispatch('order_info/changePackageGoods', getters['goods_info/getPackageGoods'])
        .then(()=>{
          dispatch('order_info/refreshSubGoods')
        })
        .then(() => {
          return commit('setTermPriceList')
        })

  },
  addSubGoods({dispatch, commit}, {main_goods_id, id, quantity, volume, cost, per_volume, sort, name, volume_unit, term_unit}){
    dispatch('order_info/addSubGoods', {main_goods_id, id, quantity, volume, cost, per_volume, sort, name, volume_unit, term_unit})
        .then(() => {
          return commit('setTermPriceList')
        })
  },
  removeSubGoods({dispatch, commit}, subGoodsInfo){
    dispatch('order_info/removeSubGoods', subGoodsInfo)
        .then(() => {
          return commit('setTermPriceList')
        })
  },
  checkDomain({getters, dispatch}, domain){
    let domainDiscountRuleList = getters["goods_info/getDomainDiscountRuleListForInstallationCost"]
    let mainGoodsId = getters["order_info/getMainGoodsId"]
    
    if(domainDiscountRuleList.length > 0){
      return wwwHiworksapi.checkDomain(domain)
        .then((apiResponse) => {
          let flag = apiResponse.flag
          let isPossible = apiResponse.is_possible
          let msg = apiResponse.msg

          if(!isPossible){
            dispatch('order_info/setDomainDiscountRule', {
              domainDiscountRule : null,
              mainGoodsId,
              msg : msg,
            })
            return Promise.resolve({
              flag: flag,
              isPossible: isPossible,
            })
          } else{
            let domainDiscountRule = domainDiscountRuleList.find((discountInfo)=>{
              return discountInfo.status === flag
            })

            dispatch('order_info/setDomain', domain)
            if(domainDiscountRule){
              dispatch('order_info/setDomainDiscountRule', {
                domainDiscountRule,
                mainGoodsId,
                msg,
                flag
              })
            }
            return Promise.resolve({
              flag: flag,
              isPossible: isPossible,
            })
          }
        })
    }
  },
  setDomainInit({dispatch, getters}){
    let mainGoodsId = getters["order_info/getMainGoodsId"]
    dispatch('order_info/setDomainDiscountRule', {
      domainDiscountRule : null,
      mainGoodsId,
      msg : null,
    })
    dispatch('order_info/setDomainInit')
  },
  setLoading({commit}, isLoading){
    commit('setLoading', isLoading)
  },
}

export default new Vuex.Store({
  state: initialState,
  modules:{
    'goods_info' : goodsInfo,
    'order_info' : orderInfo,
  },
  mutations,
  actions,
  getters,
  strict: process.env.NODE_ENV !== 'production'
})
